import React, { useReducer } from 'react'
import { ACTIONS, EVENTS, LIFECYCLE } from 'react-joyride'
import PropTypes from 'prop-types'

import joyrideContext from './joyrideContext'
import joyrideReducer from './joyrideReducer'
import {
  BUY_NEW_SIM_STEPS,
  MIGRATE_SIMS_STEPS,
  ONBOARDING_STEPS,
  TRACK_ORDER_STEPS
} from './joyrideSteps'

export const JoyrideState = (props) => {
  const endTour = () => {
    setRun(false)
    setActive(false)
    setStepIndex(0)
  }

  const onboardingTourCallback = (data) => {
    const { action, type, lifecycle } = data
    switch (type) {
      case EVENTS.STEP_AFTER:
        if (action === ACTIONS.NEXT) {
          incStepIndex()
        } else if (action === ACTIONS.PREV) {
          decStepIndex()
        } else if (lifecycle === LIFECYCLE.COMPLETE) {
          endTour()
        }
        break
      case EVENTS.TOUR_END:
        endTour()
    }
  }

  const buyNewSimCallback = (data) => {
    const { action, index, type, lifecycle } = data
    switch (type) {
      case EVENTS.STEP_AFTER:
        if (action === ACTIONS.NEXT) {
          if (index === 0) {
            setRun(false)
            setStepIndex(1)
          } else if (index === 1) {
            setRun(false)
            setStepIndex(2)
          } else if (index === 2) {
            setRun(false)
            setStepIndex(3)
          } else if (index === 3) {
            setRun(false)
            setStepIndex(4)
          } else {
            incStepIndex()
          }
        } else if (action === ACTIONS.PREV) {
          decStepIndex()
        } else if (lifecycle === LIFECYCLE.COMPLETE) {
          endTour()
        }
        break
      case EVENTS.TOUR_END:
        endTour()
    }
  }

  const trackOrderCallback = (data) => {
    const { action, index, type, lifecycle } = data
    switch (type) {
      case EVENTS.STEP_AFTER:
        if (action === ACTIONS.NEXT) {
          if (index === 0) {
            setRun(false)
            setStepIndex(1)
          } else {
            incStepIndex()
          }
        } else if (action === ACTIONS.PREV) {
          decStepIndex()
        } else if (lifecycle === LIFECYCLE.COMPLETE) {
          endTour()
        }
        break
      case EVENTS.TOUR_END:
        endTour()
    }
  }

  const migrateSimsCallback = (data) => {
    const { action, index, type, lifecycle } = data
    switch (type) {
      case EVENTS.STEP_AFTER:
        if (action === ACTIONS.NEXT) {
          if (index === 0) {
            setRun(false)
            setStepIndex(1)
          } else if (index === 2) {
            setRun(false)
            setStepIndex(3)
          } else {
            incStepIndex()
          }
        } else if (action === ACTIONS.PREV) {
          decStepIndex()
        } else if (lifecycle === LIFECYCLE.COMPLETE) {
          endTour()
        }
        break
      case EVENTS.TOUR_END:
        endTour()
    }
  }

  const initialState = {
    run: false,
    tourActive: false,
    stepIndex: 0,
    steps: ONBOARDING_STEPS,
    callBack: onboardingTourCallback
  }

  const [state, dispatch] = useReducer(joyrideReducer, initialState)

  const setActive = async (value) => {
    dispatch({
      type: 'SET_ACTIVE',
      payload: value
    })
  }

  const setRun = async (value) => {
    dispatch({
      type: 'SET_RUN',
      payload: value
    })
  }
  const setStepIndex = async (value) => {
    dispatch({
      type: 'SET_STEP_INDEX',
      payload: value
    })
  }

  const incStepIndex = async () => {
    dispatch({
      type: 'INC_STEP_INDEX'
    })
  }

  const decStepIndex = async () => {
    dispatch({
      type: 'DEC_STEP_INDEX'
    })
  }

  const setType = (type) => {
    if (type === 'onboarding') {
      dispatch({
        type: 'SET_TOUR_TYPE',
        steps: ONBOARDING_STEPS,
        callback: onboardingTourCallback
      })
    } else if (type === 'buyNewSim') {
      dispatch({
        type: 'SET_TOUR_TYPE',
        steps: BUY_NEW_SIM_STEPS,
        callback: buyNewSimCallback
      })
    } else if (type === 'trackOrder') {
      dispatch({
        type: 'SET_TOUR_TYPE',
        steps: TRACK_ORDER_STEPS,
        callback: trackOrderCallback
      })
    } else if (type === 'migrateSIMs') {
      dispatch({
        type: 'SET_TOUR_TYPE',
        steps: MIGRATE_SIMS_STEPS,
        callback: migrateSimsCallback
      })
    }
  }

  return (
    <joyrideContext.Provider
      value={{
        run: state.run,
        stepIndex: state.stepIndex,
        steps: state.steps,
        tourActive: state.tourActive,
        callBack: state.callBack,
        setActive,
        setRun,
        setStepIndex,
        incStepIndex,
        decStepIndex,
        setType
      }}
    >
      {props.children}
    </joyrideContext.Provider>
  )
}

JoyrideState.propTypes = {
  children: PropTypes.node
}
